import React, { useEffect, useState } from 'react';
import { get } from 'lodash';
import { makeStyles, Typography } from '@material-ui/core';
import { Auth } from 'aws-amplify';

import { Loader, Box } from 'components';
import { successImage } from 'assets/index';

import ChangeInviteUserPassword from './ChangeInviteUserPassword';

const useStyles = makeStyles((theme) => ({
  verifyBoxCenter: {
    height: 'calc(100vh - 104px)',
  },
  verifyBoxContent: {
    display: 'block',
    textAlign: 'center',
    padding: '130px 5% 30px',
  },
  successImg: {
    marginBottom: 30,
    height: 250,
  },
  verifySuccessTxt: {
    color: theme.palette.error.contrastText,
    fontSize: 23,
    fontWeight: 600,
  },
}));

type Props = {
  match: any;
};

//Called when admin invites investor
const Invite = ({ match }: Props) => {
  const classes = useStyles();

  const [isVerifying, setIsVerifying] = useState<boolean>(true);
  const [error, setError] = useState<string>('');
  const [user, setUser] = useState<any>({});
  const [isVerified, setIsVerified] = useState<boolean>(false);

  useEffect(() => {
    setIsVerifying(true);
    Auth.signIn({
      username: get(match, 'params.username'),
      password: get(match, 'params.password'),
    })
      .then((res: any) => {
        if (res.challengeName === 'NEW_PASSWORD_REQUIRED') {
          setIsVerified(true);
          setIsVerifying(false);
          setUser(res);
        }
      })
      .catch((error) => {
        setError(
          get(
            error,
            'message',
            'Something went wrong, please try again later.',
          ),
        );
        setIsVerifying(false);
      });
  }, []);

  return (
    <Box className={classes.verifyBoxCenter}>
      {!isVerified && (
        <Box className={classes.verifyBoxContent}>
          {isVerifying && (
            <>
              <Loader />
            </>
          )}
          {error && (
            <>
              <img
                src={successImage}
                alt={successImage}
                className={classes.successImg}
              />
              <Typography
                variant="h2"
                gutterBottom
                className={classes.verifySuccessTxt}
              >
                {error}
              </Typography>
            </>
          )}
        </Box>
      )}
      {isVerified && <ChangeInviteUserPassword user={user} />}
    </Box>
  );
};

export default Invite;
